import { combineReducers } from 'redux';

import attachments from '../attachments/reducers';
import authenticationKey from './authenticationKey';
import completeLoadingStatus from './completeLoadingStatus';
import documentId from './documentId';
import field from './field';
import file from './file';
import host from './host';
import isAttaching from './isAttaching';
import isLastInPersonSigner from './isLastInPersonSigner';
import isLastOrder from './isLastOrder';
import isLoading from './isLoading';
import isNeedFirstFocus from './isNeedFirstFocus';
import name from './name';
import participant from './participant';
import participantUserType from './participantUserType';
import pdfArrayBuffer from './pdfArrayBuffer';
import requester from './requester';
import step from './step';
import tabKeyCount from './tabKeyCount';
import termOfUseUrl from './termOfUseUrl';
import tracker from './tracker';

export default combineReducers({
  attachments,
  authenticationKey,
  completeLoadingStatus,
  documentId,
  field,
  file,
  isAttaching,
  isLastOrder,
  isLoading,
  isNeedFirstFocus,
  name,
  participant,
  participantUserType,
  pdfArrayBuffer,
  requester,
  step,
  tabKeyCount,
  termOfUseUrl,
  tracker,
  isLastInPersonSigner,
  host,
});
